export const iframeRegex = /(<iframe.*?><\/iframe>)/g;

export const splitByIframe = (input) => {
    return input.split(iframeRegex).filter((part) => !!part);
};
